import React, { useEffect, useState } from "react";
import { MultiSelect } from "./ui/multi-select";
import { api } from "../lib/api";


/** Active zones of the tenant, fetched once per municipality. */
export function useZones(code) {
  const [zones, setZones] = useState([]);
  useEffect(() => {
    if (!code) return undefined;
    let alive = true;
    api.get(`/t/${code}/masters/zones`, { params: { include_inactive: false } })
      .then((r) => { if (alive) setZones(r.data || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [code]);
  return zones;
}

/**
 * Phase 137 — compact zone dropdown for report toolbars. Phase 176: MULTI-select — `value` is a comma-joined list of
 * zone ids ("" = all) and `onChange` receives the same shape, so every caller keeps passing it straight to the API.
 * Pass `zones` to reuse a list you already have; otherwise they are fetched.
 */
export function ZoneSelect({ code, value, onChange, zones: zonesProp, className = "w-[200px]", size = "sm",
                             placeholder = "All zones", disabled = false, testId = "zone-select" }) {
  const fetched = useZones(zonesProp ? null : code);
  const zones = zonesProp || fetched;
  const selected = String(value || "").split(",").map((x) => x.trim()).filter(Boolean);
  return (
    <MultiSelect options={zones.map((z) => ({ value: z.id, label: z.zone_name, hint: z.zone_code || undefined }))}
      value={selected} onChange={(ids) => onChange(ids.join(","))} disabled={disabled}
      allLabel={placeholder} noun="zone" placeholder="Search zones…" className={`${size === "sm" ? "h-9" : "h-10"} ${className}`} testId={testId} />
  );
}

export default ZoneSelect;
